import { render, staticRenderFns } from "./No12.vue?vue&type=template&id=5d3ec7d6&scoped=true"
import script from "./No12.vue?vue&type=script&lang=js"
export * from "./No12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ec7d6",
  null
  
)

export default component.exports